/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import classNames from 'classnames';
import FontAwesome from 'react-fontawesome';
import { compose, withProps } from 'recompose';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from 'react-google-maps';
import moment from 'moment';
import axios from 'axios';
import Breadcrumb from '../../components/Breadcrumb';
import s from './ContactUs.css';

const MyMapComponent = compose(
  withProps({
    googleMapURL:
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyDeLThqYG0AvcdD_jJFFFvgZoZoGauRQeg&v=3.exp&libraries=geometry,drawing,places',
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap,
)(props =>
  <GoogleMap
    defaultZoom={15}
    defaultCenter={{ lat: 1.7535314, lng: 103.4090493 }}
  >
    {props.isMarkerShown &&
      <Marker
        position={{ lat: 1.7535314, lng: 103.4090493 }}
        onClick={props.onMarkerClick}
      />}
  </GoogleMap>,
);

class ContactUs extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  state = {
    isMarkerShown: false,
    isFormSuccess: false,
    isFormFailed: false,
    isFormSubmitted: false,
    formMessage: '',
    name: '',
    phone: '',
    email: '',
    message: '',
  };

  componentDidMount() {
    this.delayedShowMarker();
  }

  delayedShowMarker = () => {
    setTimeout(() => {
      this.setState({ isMarkerShown: true });
    }, 300);
  };

  handleMarkerClick = () => {
    this.setState({ isMarkerShown: false });
    this.delayedShowMarker();
  };

  handleAlertClose = () => {
    this.setState({
      isFormSuccess: false,
      isFormFailed: false,
      formMessage: '',
    });
  };

  handleFormChange = event => {
    const state = this.state;
    state[event.target.name] = event.target.value;
    this.setState(state);
  };

  handleFormSubmit = event => {
    event.preventDefault();

    this.setState({
      isFormSubmitted: true,
    });

    setTimeout(() => {
      this.setState({ isFormSubmitted: false });
    }, 1000);

    const { name, phone, email, message } = this.state;

    axios({
      url: 'https://gbfjqflcwuqiwwt.form.io/maybricks-contact-form',
      method: 'post',
      data: {
        data: {
          Name: name,
          Phone: phone,
          Email: email,
          Message: message,
          DateTime: moment().format('YYYY-MM-DD HH:mmZ'),
        },
      },
      json: true,
    })
      .then(() => {
        this.setState({
          isFormSuccess: true,
          isFormFailed: false,
          formMessage: 'Contact form has been submitted successfully!',
        });
      })
      .catch(err => {
        this.setState({
          isFormSuccess: false,
          isFormFailed: true,
          formMessage: `${err.response.data.details[0].message}`,
        });
      });
  };

  render() {
    let txtSubmit = 'Submit';

    if (this.state.isFormSubmitted) {
      txtSubmit = 'Submitting';
    } else if (this.state.isFormSuccess) {
      txtSubmit = 'Submitted';
    }

    return (
      <div className={s.root}>
        <Breadcrumb title={this.props.title} />
        <div className={s.container}>
          <div className={s.contents}>
            <div className={s.map}>
              <MyMapComponent
                isMarkerShown={this.state.isMarkerShown}
                onMarkerClick={this.handleMarkerClick}
              />
            </div>
            <div className={s.contact}>
              <h1>Maybricks Sdn Bhd</h1>
              <ul className="fa-ul">
                <li>
                  <FontAwesome className="fa-li" name="map-marker" />Batu 36,
                  Jalan Air Hitam, Bukit Batu<br />81000 Kulai, Johor, Malaysia.
                </li>
                <li>
                  <FontAwesome className="fa-li" name="phone" />
                  <a href="tel:+6076511022">(60) 7 651 1022</a>,&nbsp;
                  <a href="tel:+6076511186">651 1186</a>,&nbsp;
                  <a href="tel:+6076512210">651 2210</a>
                </li>
                <li>
                  <FontAwesome className="fa-li" name="fax" />
                  <a href="tel:+6076512818">(60) 7 651 2818</a>
                </li>
                <li>
                  <FontAwesome className="fa-li" name="envelope" />
                  <a href="mailto:maybrickskulai@gmail.com">
                    maybrickskulai@gmail.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <form>
            <h1>Send us a message</h1>
            <div>
              <span
                className={classNames(
                  s.alert,
                  this.state.isFormFailed && s.error,
                  this.state.isFormSuccess && s.success,
                )}
              >
                {this.state.formMessage}
                <FontAwesome name="times" onClick={this.handleAlertClose} />
              </span>
            </div>
            <div>
              <input
                type="text"
                name="name"
                required
                placeholder="Your name (required)"
                disabled={this.state.isFormSuccess}
                onChange={this.handleFormChange}
              />
              <input
                type="text"
                name="phone"
                placeholder="Your phone"
                disabled={this.state.isFormSuccess}
                onChange={this.handleFormChange}
              />
              <input
                type="text"
                name="email"
                required
                placeholder="Your email (required)"
                disabled={this.state.isFormSuccess}
                onChange={this.handleFormChange}
              />
            </div>
            <div>
              <textarea
                name="message"
                cols="40"
                rows="10"
                required
                placeholder="Your message (required)"
                disabled={this.state.isFormSuccess}
                onChange={this.handleFormChange}
              />
            </div>
            <div>
              <input
                className="g-recaptcha"
                data-sitekey="6Le16DQUAAAAAIdiqU4ApA-COsDhDjEoYZxUJpW9"
                data-callback="YourOnSubmitFn"
                type="submit"
                value={txtSubmit}
                disabled={
                  this.state.isFormSubmitted || this.state.isFormSuccess
                }
                onClick={this.handleFormSubmit}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(ContactUs);



// WEBPACK FOOTER //
// ./src/routes/contact-us/ContactUs.js